<div class="container" [ngClass]="formTypeClass ? 'sign-up-mode':'sign-in-mode' ">
    <div class="forms-container">
        <div class="signin-signup">
            <form action="#" class="sign-in-form">
                <h2 class="title">Sign in</h2>
                <div class="input-field">
                    <i class="fas fa-user"></i>
                    <input type="text" placeholder="Username" />
                </div>
                <div class="input-field">
                    <i class="fas fa-lock"></i>
                    <input type="password" placeholder="Password" />
                </div>
                <button type="button" class="btn solid">Login</button>
                <p class="social-text">Or Sign in with social platforms</p>
                <div class="social-media">
                    <a href="#" class="social-icon">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fab fa-google"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fab fa-linkedin-in"></i>
                    </a>
                </div>
            </form>
            <form action="#" class="sign-up-form">
                <h2 class="title">Sign up</h2>
                <div class="input-field">
                    <i class="fas fa-user"></i>
                    <input type="text" placeholder="Username" />
                </div>
                <div class="input-field">
                    <i class="fas fa-envelope"></i>
                    <input type="email" placeholder="Email" />
                </div>
                <div class="input-field">
                    <i class="fas fa-lock"></i>
                    <input type="password" placeholder="Password" />
                </div>
                <button type="button" class="btn solid">Sign up</button>
                <p class="social-text">Or Sign up with social platforms</p>
                <div class="social-media">
                    <a href="#" class="social-icon">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fab fa-twitter"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fab fa-google"></i>
                    </a>
                    <a href="#" class="social-icon">
                        <i class="fab fa-linkedin-in"></i>
                    </a>
                </div>
            </form>
        </div>
    </div>

    <div class="panels-container">
        <div class="panel left-panel">
            <div class="content">
                <h3>New here ?</h3>
                <p>
                    How are you? We hope you are safe. Safety is one of the<br>
                    most important things for you . And responsiblity is the<br>
                    most important things for you and us.<br><br>
                    
                    We believe in you. So, get ready, set and go...
                </p>
                <button class="btn transparent" id="sign-up-btn" (click)="clickEvent()">
                    Sign up
                </button>
            </div>
            <img src="assets/img/undraw_Login_re_4vu2.svg" class="image" alt="" />
        </div>
        <div class="panel right-panel">
            <div class="content">
                <h3>One of us ?</h3>
                <p>
                    How are you? We hope you are safe. Safety is one of the<br>
                    most important things for you . And responsiblity is the<br>
                    most important things for you and us.<br><br>
                    
                    We believe in you. So, get ready, set and go...
                </p>
                <button class="btn transparent" id="sign-in-btn" (click)="clickEvent()">
                    Sign in
                </button>
            </div>
            <img src="assets/img/undraw_secure_login_pdn4.svg" class="image" alt="" />
        </div>
    </div>
</div>